import React from "react"
import PropTypes from "prop-types"
import { Dropdown, Menu } from "antd"
import { ROLE_MANDU_SUPER_ADMIN } from "../../../../utils/constants"
import { EllipsisOutlined } from "@ant-design/icons"
import { LOCAL_USER_ID } from "../../../../utils/storage"

const RenderOptions = (props) => (
  <div style={{ position: "absolute", right: "1rem" }}>
    <Dropdown
      overlay={
        <Menu>
          <Menu.Item
            onClick={() =>
              props.recoveryPassword({ email: props.currentData.email })
            }
            className="color-gray-low"
            key="2">
            Restablecer contraseña
          </Menu.Item>
          {props.currentData.id !== LOCAL_USER_ID() && (
            <Menu.Item
              onClick={() => props.changeRoleUser(props.currentData)}
              key="1"
              className="color-gray-low">
              Convertir en{" "}
              {props.currentData.id_role === ROLE_MANDU_SUPER_ADMIN
                ? "administrador"
                : "superadministrador"}
            </Menu.Item>
          )}
          {props.currentData.id !== LOCAL_USER_ID() && (
            <Menu.Item
              onClick={() => props.deleteUser(props.currentData)}
              className="color-red"
              key="3">
              Eliminar usuario
            </Menu.Item>
          )}
        </Menu>
      }>
      <EllipsisOutlined
        style={{ color: "#378FEE", fontSize: "26px", cursor: "pointer" }}
      />
    </Dropdown>
  </div>
)

RenderOptions.propTypes = {
  currentData: PropTypes.object,
  recoveryPassword: PropTypes.func,
  changeRoleUser: PropTypes.func,
  deleteUser: PropTypes.func,
}

export default RenderOptions
